import { C } from "../../theme/tokens";

/* Decorative blurred abstract mark — the recurring corner motif on
   course cards, in Education's own warm amber register so the
   section reads distinctly from Profile/Signals' green/gold. */
export function CourseMark() {
  return (
    <svg
      width="150"
      height="150"
      viewBox="0 0 150 150"
      style={{ position: "absolute", top: -20, right: -10, opacity: 0.9, pointerEvents: "none" }}
    >
      <defs>
        <filter id="courseBlur"><feGaussianBlur stdDeviation="7" /></filter>
      </defs>
      <g filter="url(#courseBlur)">
        <circle cx="95" cy="45" r="34" fill={C.eduBright} opacity="0.26" />
        <circle cx="120" cy="80" r="26" fill={C.edu} opacity="0.22" />
        <circle cx="75" cy="90" r="22" fill={C.eduBright} opacity="0.2" />
      </g>
    </svg>
  );
}

